export default "__VITE_ASSET__Df0p3$LQ__"